import { MutationTree } from "vuex";
import { Role } from "@/types";
import { IDataProvider } from "@/store";
import { IRoleState } from "@/store/modules/role/state";

export enum RoleMutations {
  SET_ONE = "SET_ONE_ROLE",
  SET_ALL = "SET_ALL_ROLE",
  SET_LAZY_DATA = "SET_LAZY_DATA_ROLE",
}

export const mutations: MutationTree<IRoleState> = {
  [RoleMutations.SET_ONE](state, payload: Role) {
    state.role = payload;
  },
  [RoleMutations.SET_ALL](state, payload: Role[]) {
    state.roles = payload;
  },
  [RoleMutations.SET_LAZY_DATA](state, payload: IDataProvider<Role>) {
    state.dataProvider = payload;
  },
};
